export default function Logo({ size = "md", muted = false, tone = "dark" }) {
    const sz = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-lg";
    const light = tone === "light";
    const base = light ? "text-bone" : muted ? "text-soft_muted" : "text-graphite";
    return (
        <span className={`font-display ${sz} tracking-tight ${base}`} data-testid="brand-logo">
            <span className="font-medium">Q</span>
            <span className={light ? "text-bone/70" : "text-petrol"}>capital</span>
        </span>
    );
}
